var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-tel-input',_vm._b({attrs:{"placeholder":_vm._T('Phone number'),"aria-readonly":"true"},nativeOn:{"keypress":function($event){return _vm.filterPhoneNumber($event)}},model:{value:(_vm.phoneNumber),callback:function ($$v) {_vm.phoneNumber=$$v},expression:"phoneNumber"}},'vue-tel-input',_vm.vueTelBindings,false))
}
var staticRenderFns = []

export { render, staticRenderFns }